module.exports = __webpack_public_path__ + "static/media/jumbotronProduto.66adcad5.jpg";